import script from "./THeaderBalance.vue?vue&type=script&lang=ts&setup=true"
export * from "./THeaderBalance.vue?vue&type=script&lang=ts&setup=true"

import "./THeaderBalance.vue?vue&type=style&index=0&id=5ef5f4b3&lang=css"

const __exports__ = script;

export default __exports__